import { render, staticRenderFns } from "./nullData.vue?vue&type=template&id=7068ee5e&scoped=true&"
import script from "./nullData.vue?vue&type=script&lang=js&"
export * from "./nullData.vue?vue&type=script&lang=js&"
import style0 from "./nullData.vue?vue&type=style&index=0&id=7068ee5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068ee5e",
  null
  
)

export default component.exports